import React from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getFirstDocId } from 'src/utils/docs';

const Index: React.FC = () => {
  const { replace } = useRouter();

  React.useEffect(() => {
    replace(`/docs/${getFirstDocId()}`);
  });

  return (
    <Head>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
  );
};

export default Index;
